module.exports = __webpack_public_path__ + "static/assets/d53ce878365befc12e6c1561420faf04.svg";